import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./App.css";
import "./responsive.css";

import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import React, { useEffect, useState } from "react";

import AddClient from "./Component/Admin/Client/AddClient";
import AddPlan from "./Component/Admin/Plan/AddPlan";
import AdminBots from "./Component/Admin/Bot/AdminBots";
import AdminChatHistory from "./Component/Admin/ChatHistory/AdminChatHistory";
import AdminCreateBot from "./Component/Admin/Bot/AdminCreateBot";

import ChangePassword from "./Component/User/ChangePassword";
import ChatHistory from "./Component/User/ChatHistory/ChatHistory";
import ClientChatbot from "./Component/ClientChatbot";
import Clients from "./Component/Admin/Client/Clients";
import DocList from "./Component/Admin/Client/DocList";
import EditClient from "./Component/Admin/Client/EditClient";
import EditDoc from "./Component/Admin/Client/EditDoc";
import Footer from "./Component/User/Layout/Footer";
import FreeChatbot from "./Component/FreeChatbot";
import Header from "./Component/Admin/Layout/Header";
import HeaderBefore from "./Component/User/Layout/HeaderBefore";
import HeaderUser from "./Component/User/Layout/Header";
import Login from "./Component/Admin/Login";
import MyProfile from "./Component/User/MyProfile";
import PlansList from "./Component/Admin/Plan/PlansList";
import RateLimit from "./Component/Admin/RateLimit";
import Setting from "./Component/Admin/Setting";
import Sidebar from "./Component/Admin/Layout/Sidebar";
import UploadDoc from "./Component/Admin/Client/UploadDoc";
import UserBotsNew from "./Component/User/Bot/UserBotsNew";
import UserCreateBot from "./Component/User/Bot/UserCreateBot";
import UserDocEdit from "./Component/User/Doc/UserDocEdit";
import UserLogin from "./Component/User/Login";
import UserUploadDoc from "./Component/User/Doc/UserUploadDoc";
import { useSelector } from "react-redux";

function App() {
  const botId = localStorage.getItem("firstBot");
  const [isPublicChat, setIsPublicChat] = useState(true);
  const [isSidebarActive, setSidebarActive] = useState(false);
  const toggleSidebar = () => {
    setSidebarActive(!isSidebarActive);
  };
  useEffect(() => {
    const currentPath = window.location.pathname;
    setIsPublicChat(currentPath.includes("public-chatbot"));
  }, []);
  const isLoggedIn = useSelector((state) => state.user.userData);
  const isAdmin = useSelector((state) => state.user.IsUserLevel);

  if (isAdmin === "admin") {
    return (
      <div
        className={`dashboard-main ${
          isSidebarActive ? "dashboard-compact" : ""
        }`}
      >
        <Router basename="/">
          {isLoggedIn && <Sidebar onToggleSidebar={toggleSidebar} />}
          {isLoggedIn && <Header onToggleSidebar={toggleSidebar} />}
          <div className="dashboard-content">
            <Routes>
              <Route
                path="/admin"
                element={
                  isAdmin === "admin" ? <Clients /> : <Navigate to="/admin" />
                }
              />
              <Route
                path="/admin/clients"
                element={
                  isAdmin === "admin" ? <Clients /> : <Navigate to="/admin" />
                }
              />
              <Route
                path="/admin/add-client"
                element={
                  isAdmin === "admin" ? <AddClient /> : <Navigate to="/admin" />
                }
              />
              <Route
                path="/admin/rate-limit"
                element={
                  isAdmin === "admin" ? <RateLimit /> : <Navigate to="/admin" />
                }
              />
              <Route
                path="/admin/edit-client/:id"
                element={
                  isAdmin === "admin" ? (
                    <EditClient />
                  ) : (
                    <Navigate to="/admin" />
                  )
                }
              />
              <Route
                path="/admin/doc-list/:id"
                element={
                  isAdmin === "admin" ? <DocList /> : <Navigate to="/admin" />
                }
              />
              <Route
                path="/admin/upload-doc/:id"
                element={
                  isAdmin === "admin" ? <UploadDoc /> : <Navigate to="/admin" />
                }
              />
              <Route
                path="/admin/edit-client-doc/:id"
                element={
                  isAdmin === "admin" ? <EditDoc /> : <Navigate to="/admin" />
                }
              />
              <Route
                path="/admin/my-bots/:id"
                element={
                  isAdmin === "admin" ? (
                    <AdminCreateBot />
                  ) : (
                    <Navigate to="/admin" />
                  )
                }
              />
              <Route
                path="/admin/my-bots/:id/:bot"
                element={
                  isAdmin === "admin" ? <AdminBots /> : <Navigate to="/admin" />
                }
              />
              <Route
                path="/admin/my-bots/:id/:bot"
                element={
                  isAdmin === "admin" ? (
                    <AdminChatHistory />
                  ) : (
                    <Navigate to="/admin" />
                  )
                }
              />
              <Route
                path="/admin/plans-list"
                element={
                  isAdmin === "admin" ? <PlansList /> : <Navigate to="/admin" />
                }
              />
              <Route
                path="/admin/add-plan/:id?"
                element={
                  isAdmin === "admin" ? <AddPlan /> : <Navigate to="/admin" />
                }
              />
              <Route
                path="/admin/setting"
                element={
                  isAdmin === "admin" ? <Setting /> : <Navigate to="/admin" />
                }
              />
            </Routes>
          </div>
        </Router>
      </div>
    );
  } else if (isAdmin === "user") {
    return (
      <>
        <Router basename="/">
          <HeaderUser />
          <Routes>
            <Route
              path="/"
              element={
                isLoggedIn ? (
                  <Navigate to={botId ? `/my-bots/${botId}` : "/my-bots"} />
                ) : (
                  <Navigate to="/login" />
                )
              }
            />
            <Route
              path="/my-bots"
              element={isLoggedIn ? <UserCreateBot /> : <Navigate to="/" />}
            />
            {/* <Route path="/my-bots/:id" element={isLoggedIn ? <UserBots /> : <Navigate to="/" />} /> */}
            <Route
              path="/my-bots/:id"
              element={isLoggedIn ? <UserBotsNew /> : <Navigate to="/" />}
            />
            {/* <Route path="/my-docs" element={isLoggedIn ? <UserDoc /> : <Navigate to="/" />} /> */}
            <Route
              path="/user-doc-edit/:id"
              element={isLoggedIn ? <UserDocEdit /> : <Navigate to="/" />}
            />
            {/* <Route path="/my-bots/:id" element={isLoggedIn ? <UserBotsNew/> : <Navigate to="/" />} /> */}
            <Route
              path="/user-upload-doc"
              element={isLoggedIn ? <UserUploadDoc /> : <Navigate to="/" />}
            />
            <Route
              path="/my-profile"
              element={isLoggedIn ? <MyProfile /> : <Navigate to="/" />}
            />
            <Route
              path="/changePassword"
              element={isLoggedIn ? <ChangePassword /> : <Navigate to="/" />}
            />
            <Route
              path="/chat-history"
              element={isLoggedIn ? <ChatHistory /> : <Navigate to="/" />}
            />
            <Route path="/public-chatbot/:id" element={<FreeChatbot />} />
          </Routes>
          <Footer />
        </Router>
      </>
    );
  }else if (isPublicChat) {
    return (
      <>
        <Router basename="/">
          <Routes>
            <Route path="/public-chatbot/:id" element={<FreeChatbot />} />
          </Routes>
        </Router>
      </>
    );
  } else {
    return (
      <>
        <Router basename="/">
          <HeaderBefore />
          <Routes>
            <Route path="/admin" element={<Login />} />
            <Route path="/login" element={<UserLogin />} />
            <Route path="/client-chatbot/:id" element={<ClientChatbot />} />
            {!isLoggedIn && (
              <>
                <Route path="*" element={<UserLogin />} />
              </>
            )}
            {isLoggedIn && <Route path="*" element={<UserLogin />} />}
            <Route path="/" element={<UserLogin />} />
          </Routes>
          <Footer />
        </Router>
      </>
    );
  }
}

export default App;
